import {StorageManager} from './../../common/storage-manager.class';
import {Injectable} from '@angular/core';
//import {BaseApi} from './base-api.class';
import {UserModel} from '../../models/user.model';
import {Utils} from '../../common/utils';
import {HttpClient} from '@angular/common/http';
//import {BaseResponseModel} from '../../models/base-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoginApiService{
    protected fakeValidUser: UserModel = new UserModel('admin', 'admin');

    private fakeMode = true;
    // public isGuest: boolean = false;

    constructor(private _: HttpClient) {
        this.fakeValidUser.id = '0';
    }

    public getCurrentUser(): UserModel {
        return StorageManager.getUser();
    }

    /*
    public getUsers(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.get('user/getusers')
                .then(this.getEntityDataList.bind(this))
                .then(resolve);
        });
    }
    */

    public doLogin(user: UserModel): Promise<boolean> {
        if(this.fakeMode){
            return new Promise((resolve, reject) => {
                this.openSession(user);
                resolve(true);
            })
        }
       
    }

    public checkCurrentSession(): Promise<Boolean> {
        return new Promise((resolve, reject) => {
            if (this.isLoggedIn()) {
                resolve(true);
                // TODO: Not secure
                // this.doLogin(this.getCurrentUser())
                //   .then(resolve);
            } else {
                resolve(false);
            }
        });
    }

    public isLoggedIn(): boolean {
        return Utils.isSet(this.getCurrentUser());
    }

    public closeSession() {
        StorageManager.deleteUser();
    }

    public openSession(user: UserModel) {
        StorageManager.saveUser(user);
    }

}
